
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/[id]/add_images",
      function () {
        return require("private-next-pages/restaurants/[id]/add_images.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/[id]/add_images"])
      });
    }
  